<template>
	<!-- 供应商部分的登录 -->
	<div class="app fulldiv BackStrap" v-loading="allload" element-loading-background="rgba(255, 255, 255, 0.8)">
		<el-container class="fulldiv flex-vc">
			<el-main class="login_contain">
				<div class="content">
					<!-- <el-tab-pane label="神通科技集团股份有限公司供应商协同平台" name="gys">
						<el-tabs v-model="loginMethod" id="morePhone" @tab-click="clearVail">
							<el-tab-pane label="密码登录" name="form"></el-tab-pane>
							<el-tab-pane label="手机登录" name="phone"></el-tab-pane>
						</el-tabs>
					</el-tab-pane> -->
					<h2>{{title}}</h2>
					<div class="line"></div>
					<template v-if="loginMethod == 'form'">
						<el-form ref="form" :model="form" :rules="rules" @submit.native.prevent v-if="!tempLogin">
							<!-- v-if="form.accountType=='gys'" -->
							<el-form-item class="form-group" prop="username">
								<el-input v-model="form.username" prefix-icon="el-icon-s-custom" type="text" autocomplete="off"
									placeholder="代码" name="txtusername" id="txtusername">
								</el-input>
							</el-form-item>
							<el-form-item class="form-group" prop="pass">
								<el-input v-model="form.pass" prefix-icon="el-icon-lock" type="password" autocomplete="off"
									placeholder="密码" name="txtpassword" id="txtpassword">
								</el-input>
							</el-form-item>
							<!-- <el-form-item prop="checked" class="_login_check">
								<el-checkbox v-model="form.checked" @change="changLo">免登30天</el-checkbox>
							</el-form-item> -->
							<el-form-item class="form-actions">
								<el-button type="submit" class="btn blue pull-right" native-type="submit" style="width:100%;"
									@click="onSubmit" :disabled="loading" :loading="loading">
									登录
								</el-button>
							</el-form-item>
							<div class="create-account">
							</div>
						</el-form>
						<template v-else>
							<div class="dragV">
								<dragV :closeCallback="dragclose" :callback="dragcall" @operate="dragoperate = $event">
								</dragV>
							</div>
						</template>
					</template>
					<template v-else>
						<template v-if="!afterLogin">
							<el-form ref="phoneform" :model="phoneform" :rules="rerules" @submit.native.prevent>
								<el-form-item label="手机号" class="form-group" prop="phone">
									<el-input v-model="phoneform.phone" prefix-icon="el-icon-s-custom" type="text" autocomplete="off"
										placeholder="手机号" name="txtphone" id="txtphone">
									</el-input>
								</el-form-item>
								<el-form-item label="验证码" class="form-group" prop="yzcode">
									<div class="flex flex_row flex-nowrap flex-vc" style="width: 100%;">
										<el-input v-model="phoneform.yzcode" prefix-icon="el-icon-s-custom" type="text" autocomplete="off"
											placeholder="验证码" name="txtyzcode" id="txtyzcode">
											<vxe-button type="text" class="tool-btn _icon_button" slot="suffix" title="获取验证码" @click="smssend"
												:disabled="smsload">
												{{ SSMText }}
											</vxe-button>
										</el-input>
									</div>
								</el-form-item>
								<el-form-item class="form-actions">
									<el-button type="submit" class="btn blue pull-right" native-type="submit" style="width:100%;"
										@click="smsLogin" :disabled="loading" :loading="loading">
										登录
									</el-button>
								</el-form-item>
								<div class="create-account">
								</div>
							</el-form>
						</template>
						<template v-else>
							<div class="dragV">
								<dragV :closeCallback="dragclose" :callback="dragcall" @operate="dragoperate = $event">
								</dragV>
							</div>
						</template>
					</template>
				</div>
			</el-main>
			<div class="pic">
				<img style="width:100%;height:100%;background-repeat: no-repeat;background-size: 100% 100%;" :src="'static/img/team.jpg'"/>
			</div>
		</el-container>
	</div>
</template>

<script>
// import adata from '../json/TableData.json'
import dragV from '../../components/dragVierity.vue'
export default {
	components: {
		dragV
	},
	data() {
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'));
			} else {
				if (this.registform.recheckpass !== '') {
					this.$refs.registform.validateField('recheckpass');
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.registform.repass) {
				callback(new Error('两次输入密码不一致'));
			} else {
				callback();
			}
		};
		var valiAboutPass = (rule, value, callback) => {
			let error = ''
			if (this.form.username === '') {
				error = '请输入用户名';
			}
			if (this.form.repass === '') {
				if (error != '') error += ',';
				error += '请输入用户名';
			}
			if (error != '') callback(new Error(error));
			else callback();
		};
		return {
			// table: {
			// 	pagesize: 15,
			// 	currentPage: 1,
			// 	head: [],
			// 	data: [],
			// 	_height: undefined
			// },
			FormID: 'Login',
			// dialogFormVisible:false,//修改对话框
			userdata: null, //用户数据
			loading: false, //按钮登录 loading样式
			loading1: false,
			yzload: false,
			smsload: false,
			form: { //登录表单
				username: '',
				pass: '',
				checked: false,
				accountType: 'gys'
			},
			registform: { //注册表单
				reusername: '',
				repass: '',
				recheckpass: ''
			},
			rules: { //登录表单规则
				username: [{
					required: true,
					message: '用户名不能为空',
					trigger: 'blur'
				}],
				pass: [{
					required: true,
					message: '密码不能为空',
					trigger: 'blur'
				},],
				code: [{
					required: this.IsGYS,
					message: '防伪码不能为空'
				},],
				autocode: [{
					required: this.tempLogin,
					message: '动态验证码不能为空'
				},]
			},
			rerules: { //注册表单规则
				phone: [{
					required: true,
					message: '手机号不能为空',
					trigger: 'blur'
				}],
				yzcode: [{
					required: true,
					message: '验证码不能为空',
					trigger: 'blur'
				},]
			},
			footData: null, //底部显示的内容
			allload: false,
			closeTip: false,
			YZImg: '',
			tempLogin: false,
			IsGYS: false,
			sendLoad: false,
			loginMethod: 'form',
			phoneform: {},
			timeoutserServlet: null,
			VeriyServlet: null,
			SSMText: '获取验证码',
			afterLogin: false,
			dragoperate: false,
			title:'',
			HasLoginDragVaild:false
		}
	},
	computed: {
		platform() {
			return this.$BH().checkCurrentPlat()
		}
	},
	destroyed() {
		if (this.timeoutserServlet) this.timeoutserServlet.stop();
		if (this.VeriyServlet) this.VeriyServlet.stop();
	},
	methods: {
		dragcall(sign, {
			trail,
			difftime
		}) {
			try {
				if (sign == 'success') {
					//发送验证码的请求
					this.phoneform['macode'] = this.$store.getters.GUID;
					this.form['macode'] = this.$store.getters.GUID;
					//直接发起请求 校验再组件里面去校验
					this.loading = true;
					this.dragclose();
					this.onSubmitRequest(undefined, {
						trail,
						difftime
					});
				}
			} catch (e) {
				this.$BH().message(e);
				console.log(e)
			}
		},
		sendSMS() {
			try {
				this.phoneform['macode'] = this.$store.getters.GUID;
				this.form['macode'] = this.$store.getters.GUID;
				this.$BH().commit('login.sendSMS', {
					data: {
						userinfo: {
							phone: this.phoneform.phone,
							macode: this.form['macode'],
							trailYZImg: [],
							difftime: 0,
							sign: ''
						}
					},
					success: (res) => {
						this.dotimeout(); //开始前端控制计时
					},
					loadingcontrol: () => {
						this.dragclose();
					}
				});
			} catch (e) {
				this.$BH().message(e)
			}
		},
		smsLogin() {
			try {
				this.loading = true;
				this.phoneform['macode'] = this.$store.getters.GUID;
				this.form['macode'] = this.$store.getters.GUID;
				this.$BH().commit('login.SMSLogin', {
					data: {
						userinfo: this.phoneform
					},
					success: (res) => {
						let {
							stoken,
							_stoken,
							User
						} = res.data.value;
						this.$store.commit('setStoken', stoken);
						this.$store.commit('setrefreshStoken', _stoken);
						this.$store.commit('setUserName', User[0]['fnumber']);
						this.$store.commit('setUserInfo', User[0]);
						this.$store.commit('appendUserInfo', {
							"_logIn": true
						});
						this.$store.commit('setSerInvrtCheck')
						// this.$router.push({
						// 	path: '/Main'
						// });
						sessionStorage.setItem('userType', 'gys');
						window.location.href = "Main.html"
					},
					loadingcontrol: () => {
						this.dragclose();
						this.loading = false;
					}
				});
			} catch (e) {
				this.loading = false;
				//TODO handle the exception
				this.$BH().message(e);
			}
		},
		dragclose() {
			//刷新img 会自动上传
			this.afterLogin = false;
			this.tempLogin = false;
		},
		smssend() { //发送验证码 控制校验
			try {
				if (this.smsload) return;
				if (this.$refs.phoneform) {
					$('.dragV').css('height', `${this.$refs.phoneform.$el.offsetHeight}px`);
					this.$refs.phoneform.validateField('phone', (valid) => {
						if (!valid) {
							//不做滑动验证就直接发送信息
							// this.dragcall('success',{trail:[],difftime:0});
							this.sendSMS();
							// //跳出滑动验证，然后进行发送登录请求
							// this.afterLogin=true;
							// //如果一直没有验证就回到首页上
							// this.VeriyServlet=new window.M10.base.Interval(()=>{
							// 	if(!this.operate){
							// 		this.afterLogin=false;
							// 		this.VeriyServlet.stop();
							// 	}
							// },60000);//一分钟校验
							// if(this.VeriyServlet) this.VeriyServlet.start();
						}
					});
				} else throw '对象错误';
			} catch (e) {
				this.smsload = false;
				//TODO handle the exception
				this.$BH().message(e);
			}
		},
		dotimeout() {
			// var allTime=60;
			if (this.smsload) return;
			this.smsload = true;
			var StartText = '获取验证码';
			var StartTime = new Date().getTime();
			this.timeoutserServlet = new window.M10.base.Interval(() => {
				let diff = (new Date().getTime() - StartTime) / 1000;
				diff = Math.floor(diff);
				if (diff >= 0 && diff < 60) {
					this.SSMText = `${60 - diff} 秒`;
					// allTime-=1;
				} else {
					this.timeoutserServlet.stop();
					this.timeoutserServlet = null;
					this.SSMText = StartText;
					this.smsload = false;
				}
			}, 1000);
			console.log(this.timeoutserServlet)
			if (this.SSMText == StartText) this.timeoutserServlet.start();
		},
		clearVail() {
			if (this.$refs.form) this.$refs.form.clearValidate();
			if (this.$refs.phoneform) this.$refs.phoneform.clearValidate();
			if (this.$refs.formcheck) this.$refs.formcheck.clearValidate();
		},
		onSubmit() {
			try {
				if (this.loading) return;
				this.$refs.form.validate((valid) => {
					if (valid) {
						// //记住密码
						// if (this.form.checked) {
						// 	localStorage.setItem('rememberCheck', true)
						// 	localStorage.setItem('reusername', this.form.username)
						// 	localStorage.setItem('rePass', this.form.pass)
						// 	localStorage.setItem('tabsValue', this.form.accountType)
						// } else {
						// 	localStorage.removeItem('rememberCheck')
						// 	localStorage.removeItem('reusername')
						// 	localStorage.removeItem('rePass')
						// 	localStorage.removeItem('tabsValue')
						// }
						//按钮状态
						//发起滑动校验
						this.loading = true;
						if(this.HasLoginDragVaild){
							this.tempLogin = true;
						}else{
							this.onSubmitRequest(undefined, {});
						}
						// this.onSubmitRequest();
					} else {
						this.loading = false;
						this.closeTip = true;
						return false;
					}
				});
			} catch (e) {
				this.loading = false;
				this.closeTip = true;
				this.$BH().message(e);
				console.log(e)
			}

		},
		onSubmitRequest(sign, {
			trail,
			difftime
		}) { //自动登录的和正常点击按钮登录的
			var requestDoSuccess = (response) => {
				var setInfo = Object.assign({}, this.form);
				// localStorage.setItem('Stoken',response.data.value['stoken'])
				this.$store.commit('setStoken', response.data.value['stoken']);
				this.$store.commit('setrefreshStoken', response.data.value['_stoken']);
				this.$store.commit('setUserName', response.data.value['User'][0]['fnumber']);
				this.$store.commit('setUserInfo', response.data.value['User'][0]);
				this.$store.commit('appendUserInfo', {
					"_logIn": true
				});
				this.$store.commit('appendUserInfo', { "rePass": response.data.value['rePass'] });
				this.$store.commit('appendUserInfo', { "rePassCase": response.data.value['rePassCase'] });
				if (sign) {
					let vary = {
						trail,
						difftime
					};
					vary['code'] = this.$BH().base.hashCode(JSON.stringify(vary));
					vary['index'] = 1 + (this.$store.getters.dragV.index ? this.$store.getters.dragV.index : 0);
					this.$store.commit('appendUserInfo', {
						"dragV": vary
					});
				}
				console.log(this.$store.getters.UserInfo)
				this.$store.commit('setSerInvrtCheck');
				sessionStorage.setItem('userType','gys');
				window.location.href = "main.html";
				// if(this.$store.getters.UserInfo.accountType=='gys'&&!sign){
				// 	this.$store.commit('appendUserInfo', {"_logIn":false,"_gysCheck":this.form['checked']});//暂时先不登录
				// 	this.clearVail();
				// 	this.tempLogin=true;
				// }else{
				// 	this.$router.push({
				// 		path: '/Main'
				// 	});
				// }
			}
			// if(this.yzload&&!sign) throw '防伪码正在刷新,请重新填写后提交';
			this.form['macode'] = this.$store.getters.GUID;
			this.form['sign'] = !!sign;
			let _form = JSON.parse(JSON.stringify(this.form));
			_form['dragv'] = {
				trail,
				difftime
			};
			_form['dragv']['code'] = this.$BH().base.hashCode(JSON.stringify({
				trail,
				difftime
			}));
			// requestDoSuccess();
			this.$BH().base.http({ //获取默认的账号
				url: 'Task/Login_AKT',
				data: _form,
				success: requestDoSuccess,
				fail: ({
					data
				}) => {
					if (data.value == '1') {
						this.YZCode();
					}
					this.$BH().message(String(data.errmsg));
				},
				loadingcontrol: () => {
					this.loading = false;
				}
			});
		},
		PathToGuan() {
			window.open(this.footData.F_003, '_blank');
		},

		langlogin() {
			let url = this.$BH().base.geturlparam();
			if (JSON.stringify(url) != '{}') {
				if (url['state'] && url['code']) {
					this.allload = true;
					this.$BH().commit('login.wxlogin', {
						data: {
							userinfo: url
						},
						success: (res) => {
							console.log(res);
							this.$store.commit('setStoken', res.data.value['stoken']);
							this.$store.commit('setrefreshStoken', res.data.value['_stoken']);
							this.$store.commit('setUserName', res.data.value['User'][0]['fnumber']);
							this.$store.commit('setUserInfo', res.data.value['User'][0]);
							this.$store.commit('appendUserInfo', {
								"_logIn": true
							});
							this.$store.commit('setSerInvrtCheck')
							// this.$router.push({
							// 	path: '/cgy/Main'
							// });
							sessionStorage.setItem('userType', 'gys');
							window.location.href = "Main.html"
						},
						loadingcontrol: () => {
							this.allload = false;
						}
					});
				} else {
					this.$BH().message('登录参数丢失');
				}
			}
		},
		changLo(e) {
			if (!e) this.$store.commit('removeUser')
		},
		YZCode() {
			this.yzload = true;
			this.YZImg = ''
			this.$BH().commit('login.GetYZCode', {
				data: {
					code: this.$store.getters.GUID,
					ips: ''
				},
				success: (res) => {
					if (this.form['code'])
						this.form['code'] = '';
					this.YZImg = 'data:image/png;base64,' + res.data.value.IMG;
					this.form['TargetID'] = res.data.value.targetid;
				},
				loadingcontrol: () => {
					this.yzload = false;
				}
			});
		},
		checkCodeValid() {
			try {
				this.loading = true;
				let number = this.$store.getters.UserInfo.fnumber;
				let pnumber = this.$store.getters.UserInfo.pfnumber;
				if (!this.form['autocode'] || String(this.form['autocode']) == '') throw '动态验证码不得为空';
				this.$BH().commit('login.checkCodeValid', {
					data: {
						userinfo: {
							number: pnumber,
							gysnumber: number,
							code: this.form['autocode'],
							macode: this.form['macode'],
							checked: this.form['checked']
						}
					},
					success: (res) => {
						this.$store.commit('appendUserInfo', {
							"_logIn": true
						});
						// this.$router.push({
						// 	path: '/Main'
						// });
						sessionStorage.setItem('userType', 'gys');
						window.location.href = "Main.html"
					},
					loadingcontrol: () => {
						this.loading = false;
					}
				});
			} catch (e) {
				this.loading = false;
				//TODO handle the exception
				console.log(e);
				this.$BH().message(e);
			}
		},
		getQRCode() {
			try {
				var dofn = () => {
					let number = this.$store.getters.UserInfo.fnumber;
					let pnumber = this.$store.getters.UserInfo.pfnumber;
					this.$BH().commit('login.getQRCode', {
						data: {
							userinfo: {
								number: pnumber,
								gysnumber: number
							}
						},
						success: (res) => {
							this.$BH().message('发送成功')
						},
						loadingcontrol: () => {
							this.sendLoad = false;
						}
					});
				}
				this.sendLoad = true;
				if (this.$store.getters.UserInfo.rePass) {
					dofn();
				} else
					this.$alert('发送至邮箱后需要重新登录手机应用',
						'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						showCancelButton: true,
						callback: action => {
							// dofn();
							if (action == 'confirm') dofn();
							else this.sendLoad = false;
							console.log(action)
						}
					});


			} catch (e) {
				this.$BH().message(e);
				this.sendLoad = false;
			}
		},
		GetSet(){
			try{
				this.allload=true;
				this.$BH().base.http({
					url:'Task/Login_Set',
					success:(res)=>{
						this.title=res.data.value.LogTitle;
						this.HasLoginDragVaild=res.data.value.HasLoginDragVaild;
					},
					loadingcontrol: () => {
						this.allload = false;
					}
				})
			}catch(e){
				this.$BH().message(e);
				this.allload=false;
			}
		}
	},
	created() {
		try {
			sessionStorage.removeItem('historyCount')
			// this.userdata = adata.Login;

			//记住密码
			// this.YZCode();

			console.log(this.$store.getters.UserInfo)
			// var check = Boolean(localStorage.getItem('rememberCheck'))
			// if (check != null && check) {
			// 	var username = localStorage.getItem('reusername')
			// 	var Pass = localStorage.getItem('rePass');
			// 	this.form.accountType = localStorage.getItem('tabsValue')
			// 	this.form.username = username;
			// 	this.form.pass = Pass;
			// 	this.form.checked = check;
			// }
			if (JSON.parse(sessionStorage.getItem('GYSZT')) != null) {
				this.footData = JSON.parse(sessionStorage.getItem('GYSZT'))
			}
			
			this.GetSet();
		} catch (e) {
			this.$BH().message(e);
		}
	},
	mounted() {
		// setTimeout(() => {
		// 	$('.BackStrap').backstretch([
		// 		"static/img/back.jpg",
		// 		"static/img/back1.jpg",
		// 		"static/img/back3.jpg"
		// 	], {
		// 		fade: 1000,
		// 		duration: 8000
		// 	});
		// }, 0);

	}
}
</script>

<style scoped>
.BackStrap {
	overflow: hidden;
}

body {
	background-color: #666 !important;
}

.app {
	min-width: 0;
}

.text {
	font-size: 14px;
}

.item {
	margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
	display: table;
	content: "";
}

.clearfix:after {
	clear: both
}

.box-card {
	width: 480px;
}

.LineHover {
	color: #3456bc;
}

.LineHover:hover {
	cursor: pointer;
}

.toolH+.toolH {
	margin-top: 5px;
}

._loginTab {
	position: relative;
	top: 20%;
}

._loginTab .el-icon-close .tooltiptext {
	visibility: hidden;
	position: absolute;
	/* width: 120px; */
	background-color: #ffffff;
	color: #000000;
	text-align: center;
	padding: 10px 5px;
	border-radius: 4px;
	-webkit-border-radius: 4px;
	border: #3456bc 1px solid;
	z-index: 2;
	opacity: 0;
	transition: opacity .6s;
	box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
	-webkit-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.tooltip-bottom::after {
	content: "";
	position: absolute;
	bottom: 100%;
	left: 50%;
	/* border: #3456bc 1px solid; */
	margin-left: -5px;
	border-width: 5px;
	border-style: solid;
	border-color: transparent transparent #3456bc transparent;

}

.tooltip-bottom {
	top: 135%;
	left: 50%;
	/* top: 20px; */
	margin-left: -60px;
}

.iconClosePosi {
	position: absolute;
	top: 33px;
	left: 280px;
	z-index: 2;
	color: #3456bc;
	font-size: 14px;
}

._loginTab .el-icon-close:hover .tooltiptext {
	visibility: visible;
	opacity: 1;
}
</style>

<style lang="scss">
@import './login.scss';
</style>
